import Constants from '../constants/constants';
import { httpGet, httpPost } from './api/axios_api';

export const SESSION_TYPES = {
  OUT_OF_GYM: 1,
  HOME_PLAY: 2,
};

export async function getPlayerHomeSessions(playerID) {
  const url = `${Constants.BACKEND_URL}/get-player-home-sessions/` + playerID;
  return httpGet(url, {});
}

export async function assignPlayerToSession(playerID, gameSessionID) {
  const params = {
    player_id: playerID,
    game_session_id: gameSessionID,
  };

  const config = {
    params: params,
  };

  const url = `${Constants.BACKEND_URL}/assign-player-to-session`;
  return httpPost(url, config);
}

export async function getSessionOutOfGymStatus(playerID, gameSessionID, sessionType) {
  if (typeof sessionType === 'undefined') {
    sessionType = SESSION_TYPES.OUT_OF_GYM;
  }
  const url = `${Constants.BACKEND_URL}/get-session-out-of-gym-status/${playerID}/${gameSessionID}/${sessionType}`;

  return httpGet(url, {});
}

export async function updateSessionOutOfGymStatus(playerID, gameSessionID, sessionType, newStatus) {
  if (typeof sessionType === 'undefined') {
    sessionType = SESSION_TYPES.OUT_OF_GYM;
  }

  const params = {
    player_id: playerID,
    game_session_id: gameSessionID,
    session_type: sessionType,
  };

  if (typeof newStatus !== 'undefined') {
    params['new_status'] = newStatus;
  }

  const config = {
    params: params,
  };

  const url = `${Constants.BACKEND_URL}/update-session-out-of-gym-status`;
  return httpPost(url, config);
}

export async function unassignPlayerFromSession(playerID, gameSessionID) {
  const params = {
    player_id: playerID,
    game_session_id: gameSessionID,
  };

  const config = {
    params: params,
  };

  const url = `${Constants.BACKEND_URL}/unassign-player-from-session`;
  return httpPost(url, config);
}

export async function getGameSessionActivitiesAsync(gameSessionID, token) {
  const url = `${Constants.BACKEND_URL}/get-game-session-activities/${gameSessionID}`;
  return httpGet(url, {}, token);
}

export async function getTherapistGameSessionBank() {
  const url = `${Constants.BACKEND_URL}/get-therapist-game-sessions-bank`;
  return httpGet(url, {});
}
